import { bazaar_redirect_to_eshop_url } from 'mk/urls/functions';
import { ContactSellerActionsStep1 } from 'mk2/apps/bazaar/containers/ProductDetail/ContactSellerActionsStep1';
import { ProductEntity } from 'mk2/apps/bazaar/schemas';
import { Btn, BtnSidePadding, BtnType } from 'mk2/components/Btn';
import React from 'react';

interface OwnProps {
    product: ProductEntity;
    sellerPhone: string;
    eshopUrl: string;
}

export const ContactSellerForSeller: React.FunctionComponent<OwnProps> = ({
    product, sellerPhone, eshopUrl,
}) => {
    const phoneLink = sellerPhone ? (
        <Btn
            type={BtnType.Link}
            label={sellerPhone}
            link={`tel:${sellerPhone}`}
            linkTarget="_blank"
            linkRel="noopener"
            sidePadding={BtnSidePadding.None}
            asAnchor
        />
    ) : null;

    const eshopLink = eshopUrl ? (
        <Btn
            type={BtnType.Link}
            label={eshopUrl.replace(/^https?:\/\//, '').split('/')[0]}
            link={bazaar_redirect_to_eshop_url(product.id)}
            linkTarget="_blank"
            linkRel="noopener"
            sidePadding={BtnSidePadding.None}
            asAnchor
        />
    ) : null;

    return (
        <ContactSellerActionsStep1
            sendMsgBtn={false}
            phoneLink={phoneLink}
            eshopLink={eshopLink}
        />
    );
};
